import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const NavBar = ({ onLogout }) => {
  const location = useLocation();
  const { t } = useLanguage();

  const links = [
    { to: '/dashboard', key: 'dashboard', icon: 'fa-house' },
    { to: '/clients', key: 'clients', icon: 'fa-user-group' },
    { to: '/calendar', key: 'calendar', icon: 'fa-calendar-days' },
    { to: '/messages', key: 'messages', icon: 'fa-envelope' },
    { to: '/profile', key: 'profile', icon: 'fa-user' },
    { to: '/vitals', key: 'vitals', icon: 'fa-heart-pulse' },
    { to: '/documents', key: 'documents', icon: 'fa-file-lines' },
    { to: '/resources', key: 'resources', icon: 'fa-compass' },
    { to: '/directory', key: 'directory', icon: 'fa-people-group' },
    { to: '/news', key: 'news', icon: 'fa-newspaper' },
    { to: '/family/dashboard', key: 'family', icon: 'fa-people-roof' },
    { to: '/help', key: 'help', icon: 'fa-circle-question' }
  ];

  const rainbow = ['#dc2626', '#ea580c', '#d97706', '#ca8a04', '#65a30d', '#16a34a', '#0d9488', '#0891b2', '#2563eb', '#4f46e5', '#7c3aed', '#c026d3'];
  const sorted = [...links].sort((a, b) => t(`common.${a.key}`).localeCompare(t(`common.${b.key}`)));

  return (
    <nav className="dashboard-nav" data-testid="main-nav">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Link to="/dashboard">
          <img src="/careguard-logo.png" alt="CareGuard" className="nav-logo" style={{ cursor: 'pointer' }} />
        </Link>
        <LanguageSwitcher />
      </div>
      <div className="nav-links">
        {sorted.map((link, i) => (
          <Link
            key={link.to}
            to={link.to}
            className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
            data-testid={`nav-${link.key}`}
            title={t(`common.${link.key}`)}
            style={{ '--nav-color': rainbow[i % rainbow.length] }}
          >
            <i className={`fa-solid ${link.icon}`} style={{ marginRight: '3px', fontSize: '0.7rem' }}></i>
            {t(`common.${link.key}`)}
          </Link>
        ))}
      </div>
      <div className="nav-logout-row">
        <button onClick={onLogout} className="logout-button" data-testid="logout-button">
          <i className="fa-solid fa-right-from-bracket" style={{ marginRight: '6px' }}></i>
          {t('common.logout')}
        </button>
      </div>
    </nav>
  );
};

export default NavBar;
